// gkc_hash_code : 01FJGW9AB4VKN1PM0CVCZY1PTE
import { Storage } from "aws-amplify";

export const getImage = async (key: string, folder: string) => {
  if (key.substring(0, 4) === "http") {
    return key;
  }
  const image = await Storage.get(`${folder}/${key}`);
  return image;
};

export const getUploadVideo = async (key: string, folder: string) => {
  if (key.substring(0, 4) === "http") {
    return key;
  }
  const video = await Storage.get(`${folder}/${key}`);
  return video;
};
